import { render, staticRenderFns } from "./square_list.vue?vue&type=template&id=63df7c08&scoped=true"
import script from "./square_list.vue?vue&type=script&lang=js"
export * from "./square_list.vue?vue&type=script&lang=js"
import style0 from "./square_list.vue?vue&type=style&index=0&id=63df7c08&prod&scoped=true&lang=less"
import style1 from "./square_list.vue?vue&type=style&index=1&id=63df7c08&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63df7c08",
  null
  
)

export default component.exports